export const ActionTypes = {
  //AIRLANESs
  SET_AIRLANES: "SET_AIRLANES",
  CREATE_AIRLANES: "CREATE_AIRLANES",
  SELECTED_AIRLANES: "SELECTED_AIRLANES",
  DELETE_AIRLANES: "DELETE_AIRLANES",
  UPDATE_AIRLANES: "UPDATE_AIRLANES",
  ADD_AIRLANES_PENDING: "ADD_AIRLANES_PENDING",
  GET_AIRLANES_ERROR: "GET_AIRLANES_ERROR",
  REMOVE_SELECTED_AIRLANES: "REMOVE_SELECTED_AIRLANES",

  // bag
  UPDATE_PAGE: "UPDATE_PAGE",
  ADD_BAG: "ADD_BAG",
  BAG: "BAG",

  // user
  USER_REGISTER_PENDING: "USER_REGISTER_PENDING",
  USER_LOGIN_PENDING: "USER_LOGIN_PENDING",
  USER_REGISTER_SUCCESS: "USER_REGISTER_SUCCESS",
  USER_LOGIN_SUCCESS: "USER_LOGIN_SUCCESS",

  // categories
  GET_CATEGORY_PENDING: "GET_CATEGORY_PENDING",
  GET_CATEGORY_SUCCESS: "GET_CATEGORY_SUCCESS",
  GET_CATEGORY_ERROR: "GET_CATEGORY_ERROR",

  //cOUNTRY
  SET_COUNTRY: "SET_COUNTRY",
  CREATE_COUNTRY: "CREATE_COUNTRY",
  SELECTED_COUNTRY: "SELECTED_COUNTRY",
  DELETE_COUNTRY: "DELETE_COUNTRY",
  UPDATE_COUNTRY: "UPDATE_COUNTRY",
  ADD_COUNTRY_PENDING: "ADD_COUNTRY_PENDING",
  GET_COUNTRY_ERROR: "GET_COUNTRY_ERROR",
  REMOVE_SELECTED_COUNTRY: "REMOVE_SELECTED_COUNTRY",

  // BOOKING
  SET_BOOKING: "SET_BOOKING",
  CREATE_BOOKING: "CREATE_BOOKING",
  SELECTED_BOOKING: "SELECTED_BOOKING",
  DELETE_BOOKING: "DELETE_BOOKING",
  UPDATE_BOOKING: "UPDATE_BOOKING",
  ADD_BOOKING_PENDING: "ADD_BOOKING_PENDING",
  GET_BOOKING_ERROR: "GET_BOOKING_ERROR",
  REMOVE_SELECTED_BOOKING: "REMOVE_SELECTED_BOOKING",

  // COSTEMER customer
  SET_CUSTOMER: "SET_CUSTOMER",
  CREATE_CUSTOMER: "CREATE_CUSTOMER",
  SELECTED_CUSTOMER: "SELECTED_CUSTOMER",
  DELETE_CUSTOMER: "DELETE_CUSTOMER",
  UPDATE_CUSTOMER: "UPDATE_CUSTOMER",
  ADD_CUSTOMER_PENDING: "ADD_CUSTOMER_PENDING",
  GET_CUSTOMER_ERROR: "GET_CUSTOMER_ERROR",
  REMOVE_SELECTED_CUSTOMER: "REMOVE_SELECTED_CUSTOMER",

  // COSTEMER customer
  SET_FLIGHTS: "SET_FLIGHTS",
  CREATE_FLIGHTS: "CREATE_FLIGHTS",
  SELECTED_FLIGHTS: "SELECTED_FLIGHTS",
  DELETE_FLIGHTS: "DELETE_FLIGHTS",
  UPDATE_FLIGHTS: "UPDATE_FLIGHTS",
  ADD_FLIGHTS_PENDING: "ADD_FLIGHTS_PENDING",
  GET_FLIGHTS_ERROR: "GET_FLIGHTS_ERROR",
  REMOVE_SELECTED_FLIGHTS: "REMOVE_SELECTED_FLIGHTS",
};
